<template>
  <div>
    <data-table-card
      :items="items"
      v-on:updateData="getOrders"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons v-if="userHasPerms(['Orders create'])">
        <b-button
          class="ml-2"
          :to="{ name: 'orders-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:cards="slotProps">
        <span
          @click="
            selectedOrder = slotProps.item;
            orderDetailToggle = true;
          "
        >
          <div class="row no-gutters">
            <div class="col-12 p-3">
              <h5 class="font-weight-bold mb-0">
                <span class="text-primary float-right">{{
                  slotProps.item.order_number
                }}</span>
                {{ slotProps.item.customer.name }}
              </h5>
              <strong>{{ slotProps.item.customer.rapid_code }} </strong>
              <small class="text-muted"
                >TA {{ slotProps.item.customer.trading_as }}</small
              ><br />
              C:
              {{
                moment(new Date(slotProps.item.created_at)).format(
                  "DD MMM YY, HH:mm"
                )
              }}
              <br />
              U:
              {{
                moment(new Date(slotProps.item.updated_at)).format(
                  "DD MMM YY, HH:mm"
                )
              }}
              <br /><br />
              <span
                class="font-weight-bold"
                :class="{
                  'text-warning': slotProps.item.status == 'CAPTURED',
                  'text-info': slotProps.item.status == 'ATTENDING',
                  'text-success': slotProps.item.status == 'PROCESSED',
                }"
              >
                {{ slotProps.item.status }}
              </span>
              <span
                class="float-right badge"
                :class="{
                  'badge-warning': slotProps.item.status == 'CAPTURED',
                  'badge-success': slotProps.item.status == 'PROCESSED',
                  'badge-info': slotProps.item.status == 'ATTENDING',
                }"
                v-if="slotProps.item.branch"
                >{{ slotProps.item.branch.name }}</span
              >
            </div>
          </div>
        </span>
      </template>
    </data-table-card>

    <b-modal
      :hide-footer="true"
      title="Order Details"
      size="lg"
      v-model="orderDetailToggle"
      v-if="selectedOrder != null"
      @hidden="update"
    >
      <template #modal-header>
        <div class="row">
          <div class="col-auto">
            <span class="bg-primary text-white px-3 py-1">{{
              selectedOrder.order_number
            }}</span>
          </div>
          <div class="col">
            <h4 class="m-0">{{ selectedOrder.customer.name }}</h4>
            <small class="text-muted">{{
              selectedOrder.customer.trading_as
            }}</small>
          </div>
        </div>
        <button type="button" class="close" @click="orderDetailToggle = false">
          X
        </button>
      </template>

      <div class="row">
        <div class="col-md-6">
          <table class="table table-sm mt-2">
            <table-row label="Branch" :no-border="true"
              >{{ selectedOrder.branch.name }}
            </table-row>
            <table-row
              label="Code"
              :no-border="true"
              :copyText="selectedOrder.customer.rapid_code"
              ><strong>{{ selectedOrder.customer.rapid_code }} </strong>
            </table-row>
            <table-row label="Status" :no-border="true"
              ><span
                :class="{
                  'text-warning': selectedOrder.status == 'CAPTURED',
                  'text-success': selectedOrder.status == 'PROCESSED',
                  'text-info': selectedOrder.status == 'ATTENDING',
                }"
                ><strong>{{ selectedOrder.status }}</strong></span
              >
            </table-row>
            <table-row label="Created" :no-border="true"
              >{{
                moment(new Date(selectedOrder.created_at)).format(
                  "DD MMM YYYY, HH:mm:ss"
                )
              }}
            </table-row>
            <table-row label="Updated" :no-border="true"
              >{{
                moment(new Date(selectedOrder.updated_at)).format(
                  "DD MMM YYYY, HH:mm:ss"
                )
              }}
            </table-row>
          </table>
        </div>
        <div class="col-md-6">
          <table class="table table-sm border mt-2">
            <table-row
              label="Cust. Ref"
              :no-border="true"
              :copyText="selectedOrder.customer_reference"
              >{{ selectedOrder.customer_reference }}
            </table-row>
            <table-row
              label="Rapid Ref"
              :no-border="true"
              :copyText="selectedOrder.rapid_reference"
              >{{ selectedOrder.rapid_reference }}
            </table-row>

            <table-row label="Rep" :no-border="true"
              >{{ selectedOrder.rep.name }}
            </table-row>

            <table-row label="Location" :no-border="true"
              >{{ selectedOrder.rep_moveable.location }}
            </table-row>

            <table-row label="Clerk" :no-border="true"
              ><span v-if="selectedOrder.clerk != null">{{
                selectedOrder.clerk.name
              }}</span>
            </table-row>
            <table-row label="Notes" :no-border="true">
              <span class="text-danger font-weight-bold">
                {{ selectedOrder.note }}
              </span>
            </table-row>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
                <tr class="bg-dark text-white font-size-11 l-s-1">
                  <th>CODE</th>
                  <th>NAME</th>
                  <th class="text-center">ORDERED</th>
                  <th class="text-center">FULFILLED</th>
                  <th class="text-center">PRICE</th>
                  <th class="text-right">MANDATE</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="product in selectedOrder.order_products"
                  :key="product.id"
                >
                  <td>
                    <strong
                      :class="{
                        'text-warning':
                          product.quantity_fulfilled < product.quantity_ordered,
                        'text-danger': product.quantity_fulfilled == 0,
                      }"
                    >
                      {{ product.product.code }}
                    </strong>
                  </td>

                  <td>
                    {{ product.product.name }}
                  </td>

                  <td class="text-center">
                    {{ product.quantity_ordered }}
                  </td>

                  <td
                    class="text-center"
                    :class="{
                      'text-warning':
                        product.quantity_fulfilled < product.quantity_ordered,
                      'text-danger': product.quantity_fulfilled == 0,
                    }"
                  >
                    {{ product.quantity_fulfilled }}
                  </td>

                  <td class="text-center">
                    <strong
                      :class="{
                        'text-danger':
                          parseFloat(product.price) <
                          parseFloat(product.mandate_pricing_min),
                        'text-success':
                          parseFloat(product.price) >=
                          parseFloat(product.mandate_pricing_min),
                      }"
                      >{{ product.price | currency }}</strong
                    >
                  </td>

                  <td class="text-right">
                    <span class="text-muted">
                      {{ product.mandate_pricing_min }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row my-5">
        <div class="col-12">
          <div class="border">
            <div v-if="loading">
              <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem"
                label="Large Spinner"
              ></b-spinner>
            </div>

            <div
              v-for="comment in selectedOrder.order_comments"
              :key="comment.id"
              class="card border-bottom p-2 mb-1"
            >
              <p class="nl2br">
                {{ comment.comment }}
              </p>

               <a v-if="comment.file_url" :href="comment.file_url" target="new">
                {{ comment.file_description }}<br />
              </a>

              <img
                v-if="comment.image"
                :src="comment.image"
                class="img-fluid maxWidth300 my-2"
              />



              <div class="row">
                <div class="col-auto">
                  <b-avatar v-if="!comment.user.image"></b-avatar>
                  <b-avatar
                    v-if="comment.user.image"
                    :src="comment.user.image"
                  ></b-avatar>
                </div>
                <div class="col">
                  <h6 class="mb-0 mt-1 font-weight-bold">
                    {{ comment.user.name }}
                  </h6>
                  <small class="text-muted">
                    <i class="lni lni-calendar"></i>
                    {{
                      moment(new Date(comment.created_at)).format(
                        "DD MMM YYYY, HH:mm:ss"
                      )
                    }}

                    |

                    {{
                      moment
                        .duration(
                          moment(Date.now()).diff(
                            moment(new Date(comment.created_at)),
                            "seconds"
                          ),
                          "seconds"
                        )
                        .format("Y [year] D [day], H [hour &] m [min]")
                    }}
                    ago
                  </small>
                </div>
              </div>
            </div>

            <form-base
              :submit-status="submitStatus"
              action="Comment"
              :errors="errors"
              :loading="loading"
              v-on:handleSubmit="createComment"
            >
              <template v-slot:fields>
                <form-group label="Comment" :required="true">
                  <textarea-autosize
                    class="form-control"
                    v-model="newComment.comment"
                  />
                </form-group>

                <form-group label="Attachments">
                  <p v-if="newComment.file_id != null" class="text-success">File Loaded <i class="lni lni-checkmark"></i></p>
                  <p v-if="newComment.image_id != null" class="text-success">Image Loaded <i class="lni lni-checkmark"></i></p>
                  <b-button v-b-toggle.collapse-1 variant="secondary" size="sm"
                    >Attach image or file</b-button
                  >
                  <b-collapse id="collapse-1" class="mt-2">
                    <b-card>
                      <form-group label="Image" v-if="!fileUploading">
                        <image-upload
                          :key="imageKey"
                          @files-uploaded="
                            newComment.image_id = $event;
                            imageUploading = false;
                          "
                          @files-uploaded-started="imageUploading = true"
                          :multiple="false"
                          :imageCrop="false"
                          :validationState="imageVstate"
                          acceptedTypes="image/*"
                        ></image-upload>
                      </form-group>

                      <form-group label="File" v-if="!imageUploading">
                        <file-upload
                          :key="fileComponentKey"
                          @files-uploaded="
                            newComment.file_id = $event;
                            fileUploading = false;
                          "
                          @files-uploaded-started="fileUploading = true"
                          :multiple="false"
                        />
                        <small class="text-muted font-size-11"
                          >*Max file size is 16MB</small
                        >
                      </form-group>
                    </b-card>
                  </b-collapse>
                </form-group>
              </template>
            </form-base>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import orderRepo from "@/api/repos/orderRepo";
import dataTableCard from "@/components/common/DataTableCard";
import tableRow from "@/components/common/TableRow";
import formGroup from "@/components/common/FormGroup";
import formBase from "@/components/common/FormBase";
import imageUpload from "@/components/common/ImageUpload";
import fileUpload from "@/components/common/FileUpload";


export default {
  components: {
    dataTableCard: dataTableCard,
    tableRow: tableRow,
    formBase,
    formGroup,
    imageUpload,
    fileUpload
  },

  data() {
    return {
      selectedOrder: null,
      orderDetailToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Date Created Desc", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      filters:[],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
      newComment: { image_id: null, comment: null, commenter: "ADMIN" },
      submitStatus: null,
      errors: null,
      loading: false,
      imageUploading: false,
      imageKey: 1,
      fileComponentKey : 1,
      fileUploading : false
    };
  },

  computed: {
    imageVstate() {
      return null;
    },
  },

  mounted() {
    this.getOrders({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async update() {
      this.getOrders(
        {
          sort: this.sort,
          filters: this.filters,
          page: this.page,
          rowsPerPage: localStorage.getItem("rowsPerPage")
            ? localStorage.getItem("rowsPerPage")
            : 12,
          search: "",
        },
        true
      );
    },
    async getOrders(e, updating = false) {
      if (!updating) {
        this.isLoad = true;
      }
      try {
        let { data } = await orderRepo.enquiry(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.sort = e.sort
        this.filters = e.filters != null ? e.filters : null

        this.items = data.orders.data;
        this.totalRows = data.orders.total;
        this.page = data.orders.current_page;
        this.fromRow = data.orders.from;
        this.toRow = data.orders.to;
        this.lastPage = data.orders.last_page;

        this.filterOptions = [];

        this.filterOptions.push({
          column: "group-heading",
          label: "status",
        });

        this.filterOptions.push({
          column: "status",
          value: "CAPTURED",
          label: "CAPTURED",
        },{
          column: "status",
          value: "ATTENDING",
          label: "ATTENDING",
        },{
          column: "status",
          value: "PROCESSED",
          label: "PROCESSED",
        });


        this.filterOptions.push({
          column: "group-heading",
          label: "branches",
        });

        data.branches.forEach((b) => {
          this.filterOptions.push({
            column: "branch_id",
            value: b.id,
            label: b.name,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
    async createComment() {
      this.loading = true;
      this.submitStatus = "PENDING";

      if (this.newComment == null) {
        this.$root.$bvToast.toast("Enter comment", {
          title: "Errors on form data",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.submitStatus = "ERROR";
        this.loading = false;
      } else if (this.imageUploading == true || this.fileUploading == true) {
        this.$root.$bvToast.toast("Wait for Image/File Upload", {
          title: "Errors on form",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          let { data } = await orderRepo.comment(
            this.selectedOrder,
            this.newComment
          );
          this.selectedOrder = data.order;
          this.newComment = {
            image_id: null,
            commenter: "ADMIN",
            comment: null,
          };
          this.imageKey++;
          this.fileComponentKey++;
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.orderDetailToggle = newVal.meta && newVal.meta.orderDetailToggle;
      },
    },
  },
};
</script>
